var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStylo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB511",
    d: "M28.846 1.122a3.832 3.832 0 010 5.416L27.04 8.344l-5.418-5.417 1.806-1.805a3.832 3.832 0 015.418 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F1941",
    d: "M19.856 4.707l5.418 5.417L7.221 28.177 0 29.983l1.804-7.221z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0ZGQjUxMSIgZD0iTTI4Ljg0NiAxLjEyMmMxLjQ5NiAxLjQ5NiAxLjQ5MyAzLjkyIDAgNS40MTZMMjcuMDQgOC4zNDRsLTUuNDE4LTUuNDE3IDEuODA2LTEuODA1YzEuNDk1LTEuNDk1IDMuOTIyLTEuNDk2IDUuNDE4IDB6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTY2IC03NCkgdHJhbnNsYXRlKDE2NiA3NCkiLz4KICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiMwRjE5NDEiIGQ9Ik0xOS44NTYgNC43MDdMMjUuMjc0IDEwLjEyNCA3LjIyMSAyOC4xNzcgMCAyOS45ODMgMS44MDQgMjIuNzYyeiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE2NiAtNzQpIHRyYW5zbGF0ZSgxNjYgNzQpIi8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgStylo as ReactComponent };